import { Modal } from "react-bootstrap";
import FileManagement from "../../Accessibility/FileManagement/FileManagement";

const FileManagementModal = ({
  show,
  hide,
}) => {
  return (
      <Modal show={show} onHide={hide} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 15 }}>File Management</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <FileManagement />
        </Modal.Body>
      </Modal>
  );
};

export default FileManagementModal;
